import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11 5h1v6.72a.1.1 0 0 1-.005.02L7.02 20.03a1 1 0 0 0-.098.164l-2.867 4.779-.001.002A2 2 0 0 0 5.754 28h20.492a2 2 0 0 0 1.7-3.025l-2.54-4.234a1 1 0 0 0-.136-.226l-5.265-8.776a.1.1 0 0 1-.005-.02V5h1a1 1 0 0 0 0-2H11a1 1 0 1 0 0 2m12.142 15.855-4.862-8.103-.011-.02a2.05 2.05 0 0 1-.269-1V5h-4v6.732a2.05 2.05 0 0 1-.268 1l-.012.02-3.555 5.925c1.65-.199 3.721.152 6.281 1.428l.002.001c2.118 1.062 3.704 1.337 4.867 1.259a4.4 4.4 0 0 0 1.827-.51m-14.56.46L5.772 26h20.457l-2.057-3.429a6.4 6.4 0 0 1-2.722.79c-1.608.108-3.552-.291-5.897-1.467-3.734-1.86-5.833-1.331-6.971-.578"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconBetaFeatures = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconBetaFeatures);
export default Memo;
